import { render, staticRenderFns } from "./ParticipationDetails.vue?vue&type=template&id=184c41bd&scoped=true&"
import script from "./ParticipationDetails.vue?vue&type=script&lang=js&"
export * from "./ParticipationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationDetails.vue?vue&type=style&index=0&id=184c41bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c41bd",
  null
  
)

export default component.exports